import { harversine } from "@omni/utils/math.utils";

import { Config } from "@/utils/config.utils";

import { enrichStores } from "../storeSearch.helpers";
import { StoreUrl } from "../storeSearch.types";

// Radius = corner coordinate -> center (distance in deg)
// Use this as the radius for the search
// Filter the stores that are not inside the map polygon (the map is a rect but the search was conducted in a circle)
export const findStoresByBounds = async (
    StoresService: woosmap.map.StoresService,
    storeUrls: Array<StoreUrl>,
    tags: Array<string>,
    bounds: woosmap.map.LatLngBounds
) => {
    const topRightCoordinates = bounds.getNorthEast().toJSON();
    const centerCoordinates = bounds.getCenter().toJSON();

    const mapCenterToCornerDistanceInKm = harversine(
        topRightCoordinates,
        centerCoordinates
    );

    const query = [
        `user.locale:="${Config.getLocale()}"`,
        ...tags.map((tag) => `tag:"${tag}"`)
    ].join(" AND ");

    const storesResponse = await StoresService.search({
        query: query,
        latLng: centerCoordinates,
        radius: mapCenterToCornerDistanceInKm * 1000
    });

    const storesInBounds = storesResponse.features?.filter((store) =>
        bounds.contains({
            lat: store.geometry.coordinates[1],
            lng: store.geometry.coordinates[0]
        })
    );

    const stores = enrichStores(storesInBounds ?? [], storeUrls);

    return {
        stores: stores,
        query: query
    };
};
